import script from "./BaseFunfact.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFunfact.vue?vue&type=script&setup=true&lang=js"

import "./BaseFunfact.vue?vue&type=style&index=0&id=5621ae22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5621ae22"]])

export default __exports__